import { NgClass, NgFor, NgTemplateOutlet } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { AppService } from '@core/services/app.service';
import { SharedService } from '@core/services/shared.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { PreventParentScrollDirective } from '@shared/directives/prevent-scrolling.directive';
import { KeycloakService } from 'keycloak-angular';
import { customEcommerce } from 'src/assets/custom-ecommerce/custom';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-menu',
  imports: [TranslateModule, RouterLink, NgTemplateOutlet, NgClass, PreventParentScrollDirective,NgFor],
  templateUrl: './menu.component.html',
  styleUrl: './menu.component.scss'
})
export class MenuComponent implements OnInit{
  @Input() isHeaderBreakpoint: boolean;
  @Input() isLoggedin : boolean;
  @Input() isSmallScreen : boolean;
  
  
  activeMenuIndex : number = 0;
  isMenuOpen: boolean = false;
  isCustom : boolean = false
  customConfig: any
  isUserPR : boolean = false
  bearerUser : string
  isDropDownClosed : boolean = true;
  languageSelected : string;
  prtag : string
  languageNameSelected : any;
  displayLanguages = [];
  defaultBurgerColor : string = '#004580'
  readonly isSceltaDateAbbonamentoActive = environment.isSceltaDateAbbonamentoActive;
  filteredMenuItems = [];
  menuItems = [
    // { link: '/user/dashboard', translationKey: 'general.dashboard'},
    { link: '/il-mio-profilo', translationKey: 'general.profile' },
    { link: '/i-miei-ordini', translationKey: 'selling.my_orders' },
    { link: '/cambio-nominativo', translationKey: 'selling.registry_change' },
    { link: '/richiesta-rimessa-in-vendita', translationKey: 'selling.resale' },
    { link: '/cambio-utilizzatore-calcio', translationKey: 'selling.change_user_dropdown' },
    { link: '/cambio-supporto', translationKey: 'selling.change_support' },
    { link: '/perfezionamento', translationKey: 'selling.refinement' },
    { link: '/scelta-date-abbonamento', translationKey: 'selling.subscription_ticket.choose_subscription_date' },
    { link: '/conversione', translationKey: 'selling.conversion' },
  ];
  languages = [
    { code: 'it', name: 'Italiano' },
    { code: 'en', name: 'English' },
    { code: 'de', name: 'Deutsch' },
    { code: 'es', name: 'Español' },
    { code: 'fr', name: 'Français' },
    { code: 'pt', name: 'Português' },
    { code: 'el', name: 'Ελληνικά' },
    { code: 'ru', name: 'Русский' },
    { code: 'ro', name: 'Română' },
    { code: 'sq', name: 'Shqiptare' },
  ];

  constructor(
    private sharedService: SharedService,
    private appService: AppService,
    private keycloakAngular: KeycloakService,
    private translate: TranslateService,
    private router: Router
  ) {
    this.languageSelected = localStorage.getItem('language') || this.getDeviceLanguage();
      this.translate.setDefaultLang(this.languageSelected);
      this.translate.use(this.languageSelected);
      this.languageNameSelected = this.languageSelected ? this.languages.find(l => l.code === this.languageSelected).code : "it";
     this.customConfig = customEcommerce[this.sharedService.getCustomDomain()]
  }

  ngOnInit(): void {
    this.displayLanguages = this.languages;
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
       this.sharedService.checkCurrentRoute(event.url) ? this.setActiveMenu(1) :  this.setActiveMenu(0);
      }
    });
    this.sharedService.bearerUser$.subscribe((user) => {
      if (user) {
        let data = user['attributes'];
        if(data['prTag']&& data['prTag'][0]){
          this.prtag = data['prTag'][0];
        }    
        this.bearerUser = user.firstName + ' ' + user.lastName;
      }
    });
    
    this.isUserPR = this.sharedService.isUserPr
    this.isCustom = this.sharedService.checkRoute();
    if (this.isCustom) {
      this.filteredMenuItems = this.menuItems.filter(
        (item) => !customEcommerce[this.sharedService.getCustomDomain()].menu.myProfile.menuItemsToHide.includes(item.link)
      );
    } else {
      this.filteredMenuItems = !this.isSceltaDateAbbonamentoActive
                              ? this.menuItems.filter(item => item.link !== '/scelta-date-abbonamento')
                              : this.menuItems;
    }
    this.toggleDropdownLang(false)
  }

  onToggleMenu(value: boolean) {
    this.isMenuOpen = value;
  }

  setActiveMenu(activeMenu){
    this.activeMenuIndex = activeMenu
  }

  onLoginClick() {
    this.sharedService.onLoginParentShare();
    this.keycloakAngular.login({ prompt: 'login', locale: this.translate.currentLang || this.languageSelected || 'it' });
  }

  onLogoutClick() {
    this.appService.logout().subscribe((res) => {
      localStorage.removeItem('authToken');
      this.keycloakAngular.logout();
    }, error => {
      localStorage.removeItem('authToken');
      this.keycloakAngular.logout();
    });
  }

    changeLanguage(language) {
    this.translate.use(language.code);
    this.languageSelected = language.code;
    this.languageNameSelected = language.code;
    this.appService.setDefaultLanguage(language.code)
    this.isDropDownClosed = true
    this.toggleDropdownLang(false)
  }

  toggleDropdownLang(toggleLangs){
    if(toggleLangs){
      this.isDropDownClosed = !this.isDropDownClosed;
    }
   const selectedIndex = this.languages.findIndex(lang => lang.code === this.languageSelected);
   if (selectedIndex > -1) {
     const selectedLanguage = this.languages[selectedIndex];
     this.displayLanguages = [
       selectedLanguage,
       ...this.languages.filter((_, index) => index !== selectedIndex)
     ];
   }
  }

  toggleDropdown(){
   this.isDropDownClosed = !this.isDropDownClosed;
   const selectedIndex = this.languages.findIndex(lang => lang.code === this.languageSelected);
   if (selectedIndex > -1) {
     const selectedLanguage = this.languages[selectedIndex];
     this.displayLanguages = [
       selectedLanguage,
       ...this.languages.filter((_, index) => index !== selectedIndex)
     ];
   }
   
  }

  getDeviceLanguage(): string {
    const language = navigator.language.split('-')[0];  
    return this.sharedService.languages.includes(language) ? language : 'en';
  }

  onProdotiInVendita(){
    this.router.navigate([`pr/${this.prtag}`]);
    this.onToggleMenu(false)
  } 
}
